import { MESSAGING } from 'core/datasets/action';
import { put } from 'redux-saga/effects';

export function* updateChannelsMapMetadata(): Generator {
    yield put({ type: MESSAGING.GET_CHANNELS_MAP });
}
